module.exports = __webpack_public_path__ + "img/portugal_limes_sized.10363230.jpeg";